import { useTranslation } from "react-i18next";
import { GetOneExpeditionBoResponseDto } from "@/types/api/api-types";

export const ShipperAddressBlock = ({
  shipper,
}: {
  shipper: GetOneExpeditionBoResponseDto["shipperInfo"];
}) => {
  const { t } = useTranslation("boExpeditionForm");
  if (!shipper) {
    return <p className="text-gray-500">-</p>;
  }
  const streetLines = (shipper.streetLines ?? []).filter(Boolean);
  const cityLine = [shipper.postalCode, shipper.city].filter(Boolean).join(" ");
  const regionLine = [shipper.stateOrProvinceCode, shipper.countryCode].filter(Boolean).join(", ");

  return (
    <div className="flex flex-col gap-0.5 text-gray-900">
      {(shipper.companyName || shipper.contactName) && (
        <p className="font-bold">
          {[shipper.companyName, shipper.contactName].filter(Boolean).join(" — ")}
        </p>
      )}
      {streetLines.map((line, index) => (
        <p key={index}>{line}</p>
      ))}
      {(cityLine || regionLine) && <p>{[cityLine, regionLine].filter(Boolean).join(", ")}</p>}
      {shipper.phone && <p>{t("addressBlocks.phone", { phone: shipper.phone })}</p>}
      {shipper.email && <p>{shipper.email}</p>}
    </div>
  );
};

export const DeliveryAddressBlock = ({
  delivery,
}: {
  delivery: GetOneExpeditionBoResponseDto["deliveryInfo"];
}) => {
  const { t } = useTranslation("boExpeditionForm");
  if (!delivery) {
    return <p className="text-gray-500">-</p>;
  }
  const fullName = [delivery.firstName, delivery.lastName].filter(Boolean).join(" ");
  const cityLine = [delivery.postalCode, delivery.city].filter(Boolean).join(" ");
  const regionLine = [delivery.state, delivery.country].filter(Boolean).join(", ");

  return (
    <div className="flex flex-col gap-0.5 text-gray-900">
      {(delivery.company || fullName) && (
        <p className="font-bold">{[delivery.company, fullName].filter(Boolean).join(" — ")}</p>
      )}
      {delivery.street && <p>{delivery.street}</p>}
      {delivery.additionalInfo && <p>{delivery.additionalInfo}</p>}
      {(cityLine || regionLine) && <p>{[cityLine, regionLine].filter(Boolean).join(", ")}</p>}
      {delivery.phone && <p>{t("addressBlocks.phone", { phone: delivery.phone })}</p>}
      {delivery.email && <p>{delivery.email}</p>}
    </div>
  );
};
